import React from 'react';
import styled from 'styled-components';
import { FiArrowLeft } from 'react-icons/fi';

const Container = styled.div`
  min-height: 100vh;
  background: #0a0a0f;
  color: rgba(255, 255, 255, 0.8);
  padding: 60px 24px;
`;

const Content = styled.div`
  max-width: 720px;
  margin: 0 auto;

  h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 8px;
  }

  .updated {
    font-size: 0.85rem;
    opacity: 0.4;
    margin-bottom: 40px;
  }

  h2 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
    margin: 32px 0 12px;
  }

  p, li {
    font-size: 0.95rem;
    line-height: 1.8;
    opacity: 0.7;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;
  }
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;
  transition: color 0.2s;

  &:hover { color: #fff; }
`;

export default function PrivacyPolicy() {
  return (
    <Container>
      <Content>
        <BackButton onClick={() => window.history.back()}>
          <FiArrowLeft /> Voltar
        </BackButton>

        <h1>Política de Privacidade</h1>
        <p className="updated">Última atualização: 12 de maio de 2026</p>

        <h2>1. Informações Coletadas</h2>
        <p>Coletamos as seguintes informações:</p>
        <ul>
          <li><strong>Dados de cadastro:</strong> nome, email, CNPJ, segmento de atuação</li>
          <li><strong>Dados fiscais:</strong> XMLs de NF-e, arquivos SPED, certificados digitais (enviados voluntariamente pelo usuário)</li>
          <li><strong>Dados de uso:</strong> logs de acesso, funcionalidades utilizadas, métricas de consumo</li>
          <li><strong>Dados de pagamento:</strong> processados pela Asaas, não armazenamos dados de cartão</li>
        </ul>

        <h2>2. Uso das Informações</h2>
        <p>Utilizamos suas informações para:</p>
        <ul>
          <li>Fornecer e manter os serviços da Plataforma</li>
          <li>Processar documentos fiscais e gerar análises</li>
          <li>Realizar automações de download de XMLs junto à SEFAZ</li>
          <li>Enviar notificações sobre sua conta e assinatura</li>
          <li>Melhorar a experiência do usuário e desenvolver novas funcionalidades</li>
        </ul>

        <h2>3. Armazenamento e Segurança</h2>
        <p>
          Seus dados são armazenados em servidores no Brasil com as seguintes medidas de segurança:
        </p>
        <ul>
          <li>Criptografia em trânsito (HTTPS/TLS)</li>
          <li>Certificados digitais armazenados com criptografia</li>
          <li>Acesso restrito a sistemas internos via autenticação JWT</li>
          <li>Backups periódicos dos dados</li>
        </ul>

        <h2>4. Compartilhamento de Dados</h2>
        <p>
          <strong>Não vendemos, alugamos ou compartilhamos seus dados fiscais com terceiros.</strong>
        </p>
        <p>Podemos compartilhar dados apenas com:</p>
        <ul>
          <li><strong>Processador de pagamento (Asaas):</strong> dados necessários para cobrança</li>
          <li><strong>SEFAZ/Receita Federal:</strong> consultas realizadas com seu certificado digital, sob sua solicitação</li>
          <li><strong>Obrigações legais:</strong> quando exigido por lei ou ordem judicial</li>
        </ul>

        <h2>5. Seus Direitos (LGPD)</h2>
        <p>Conforme a Lei Geral de Proteção de Dados (LGPD), você tem direito a:</p>
        <ul>
          <li>Acessar seus dados pessoais</li>
          <li>Corrigir dados incompletos ou incorretos</li>
          <li>Solicitar a exclusão de seus dados</li>
          <li>Exportar seus dados em formato legível</li>
          <li>Revogar consentimento a qualquer momento</li>
        </ul>

        <h2>6. Retenção de Dados</h2>
        <p>
          Mantemos seus dados enquanto sua conta estiver ativa. Após o cancelamento,
          os dados são mantidos por 90 dias para permitir exportação. Após esse período,
          os dados são deletados permanentemente.
        </p>

        <h2>7. Cookies</h2>
        <p>
          Utilizamos localStorage para manter sua sessão ativa e preferências de interface.
          Não utilizamos cookies de rastreamento de terceiros.
        </p>

        <h2>8. Contato do DPO</h2>
        <p>
          Para exercer seus direitos ou tirar dúvidas sobre privacidade, entre em contato:
          <br />
          Email: privacidade@vidal-app.com
        </p>
      </Content>
    </Container>
  );
}
